import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { isDateBetweenRange } from 'utils/dayjs';

import {
  filterChangesBySearch,
  getDirectChanges,
  getRecalculatedOnlyChanges,
} from '../PendingChangesDrawer/PendingChangesDrawer.utils';

import {
  RECALCULATED_CARD_TITLE,
  SAVE_RECALCULATED_CARD_TITLE,
} from './LogHistoryDrawer.constants';

const formatToCommonDateTime = date => dayjs(date).format(COMMON_DATETIME_FORMAT);

export const filterChangesByDateRange = (changes, fromDate, toDate) => {
  const start = formatToCommonDateTime(fromDate);
  const end = formatToCommonDateTime(toDate);

  return changes.filter(change => {
    const isDateValid = dayjs(change.modifiedOn).isValid();

    return (
      isDateValid &&
      isDateBetweenRange({
        start,
        end,
        date: change.modifiedOn,
        precision: 'minute',
      })
    );
  });
};

const checkIsSearchQueryEmpty = searchQuery => !(searchQuery || '').trim().length;

// A search that names a recalculated value opens the change it belongs to, so the match is visible.
export const getSearchExpandedGroupKeys = (groups, searchQuery) => {
  if (checkIsSearchQueryEmpty(searchQuery)) {
    return {};
  }

  return Object.fromEntries(
    groups
      .filter(({ affectedChanges }) => filterChangesBySearch(affectedChanges, searchQuery).length)
      .map(({ key }) => [key, true]),
  );
};

// A save whose changes were all recalculated (its change was undone, or a pricing event or loan action
// recalculated the loan) has no direct change; its values are listed so the save stays in the history.
export const getListedChanges = groups => [
  ...getDirectChanges(groups),
  ...getRecalculatedOnlyChanges(groups),
];

export const getRecalculatedCardTitle = ({ isWrittenBySave }) =>
  isWrittenBySave ? SAVE_RECALCULATED_CARD_TITLE : RECALCULATED_CARD_TITLE;

export const buildExpandedGroupKeys = (groups, isExpanded) =>
  Object.fromEntries(groups.map(({ key }) => [key, isExpanded]));
